var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.data,"rowKey":(record, index) => index,"scroll":{ x: _vm.scrollX, y: _vm.scrollY },"pagination":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }